import { withZod } from '@remix-validated-form/with-zod'
import { z } from 'zod'
import Button from 'app/components/Button'
import FormInput from 'app/components/form/FormInput'
import { SmartForm } from 'app/components/form/SmartForm'
import { closeModal } from 'app/lib/modal'

const validator = withZod(
  z.object({
    code: z.string().min(1, { message: `Code is required` }),
  }),
) as any

interface CustomDentalCodeFormProps {
  placeholder: string
  onSave: (code: string) => void
}

export function CustomDentalCodeForm({ placeholder, onSave }: CustomDentalCodeFormProps) {
  const handleSubmit = (data?: { code: string }) => {
    if (data?.code) {
      onSave(data.code.trim())
      closeModal()
    }
  }

  return (
    <SmartForm
      id="custom-dental-code-form"
      validator={validator}
      className="flex w-[680px] flex-col gap-y-4"
      onSubmit={handleSubmit}
      hideButtons
      preventSubmit
    >
      <div className="col-span-6 px-6 py-4">
        <FormInput
          name="code"
          placeholder={placeholder}
          cols={6}
          className="rounded-lg border border-default px-4 py-3 text-body-sm text-strong placeholder:text-minimal"
          autoFocus
        />
      </div>
      <div className="col-span-6 flex justify-end gap-3 border-t border-default px-6 py-4">
        <Button type="button" label="Cancel" mode="tertiary" size="md" onClick={closeModal} />
        <Button type="submit" label="Save" mode="primary" size="md" />
      </div>
    </SmartForm>
  )
}
